export default "__VITE_ASSET__BNf1MSIc__"